import React from 'react';
import {Box, Typography, Avatar} from '@mui/material';

function ProjectPersona({url, name, children}) {
    return (
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px', mb: '16px'}}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                <Avatar src={url} alt={name} sx={{width: 72, height: 72}}/>
                <Typography variant="overline" fontWeight="bold" fontSize="14px">{name} Persona</Typography>
            </Box>
            <Box component="ul" sx={{margin: 0, paddingLeft: '20px'}}>
                {children}
            </Box>
        </Box>
    );
}

export default ProjectPersona;
